import script from "./General.vue?vue&type=script&lang=ts&setup=true"
export * from "./General.vue?vue&type=script&lang=ts&setup=true"

import "./General.vue?vue&type=style&index=0&id=01e91999&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01e91999"]])

export default __exports__